import type { Option } from '@/types/shared.types'

export enum RuleType {
  RuleTree = 'SoftwareIDM.AccessPanel.Models.RuleTree, SoftwareIDM.AccessPanelModel',
  RuleClause = 'SoftwareIDM.AccessPanel.Models.RuleClause, SoftwareIDM.AccessPanelModel',
}

export interface RuleTree {
  $type: string
  Id?: string
  Kind: string
  TreeNodes: (RuleTree | RuleClause)[]
}

export interface RuleClause {
  Id?: string
  $type: string
  Left: PathExpression
  Operator: string
  Right: Expression
}

export interface PathExpression {
  Kind: 'Path'
  Path: string[] | Option[]
  DN?: string | null
}

export type Expression = PathExpression | ValueExpression

interface ValueExpression {
  Kind?: string
  Value?: any // The actual type depends on the Kind
  DN?: string | null
}

export interface DateFilter {
  $type: 'SoftwareIDM.AccessPanel.Models.DateFilter, SoftwareIDM.AccessPanelModel'
  Dates: string[] | Option[]
  Direction: 'Ago' | 'Until'
  Days: number
  Operator: 'Eq' | 'Ne' | 'Lt' | 'Gt' | 'Lte' | 'Gte'
}

export interface RiskFilter {
  $type: 'SoftwareIDM.AccessPanel.Models.RiskFilter, SoftwareIDM.AccessPanelModel'
  Operator: 'Eq' | 'Ne' | 'Lt' | 'Gt' | 'Lte' | 'Gte'
  Risk: 'None' | 'Low' | 'Medium' | 'High' | 'Critical'
}

export interface ControlFilter {
  $type: 'SoftwareIDM.AccessPanel.Models.ControlFilter, SoftwareIDM.AccessPanelModel'
  Control: string[] | Option[]
}

export interface PrivilegeFilter {
  $type: 'SoftwareIDM.AccessPanel.Models.PrivilegeFilter, SoftwareIDM.AccessPanelModel'
  Privilege: 'Privileged' | 'NotPrivileged'
}

export type Filter = DateFilter | RiskFilter | ControlFilter | PrivilegeFilter
